import React from "react";
import IMG1 from "../../assets/ChatSync.png";
import IMG2 from "../../assets/todo.png";
import IMG3 from "../../assets/tic-tac-toe.png";
import IMG4 from "../../assets/box-office.png";
import IMG5 from "../../assets/color-generator.png";
import IMG6 from "../../assets/lorem-ipsum.png";

import "./portfolio.css";

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "ChatSync",
      img: IMG1,
      description:
        "ChatSync is a chat application built with ReactJs and Firebase10. You can chat in real-time and can also send images.",
      technologies: "ReactJs | FirebaseV10.1.0 Firestore | JavaScript || SCSS",
      link: "https://chatsync.netlify.app/",
      github: "https://github.com/amartya324/ChatSync",
    },
    {
      id: 2,
      title: "Box-office",
      img: IMG4,
      description:
        "You can search for shows and actors. You can star your fav. shows for future. The app uses an API to fetch the data for the content. All the shows that you star will go to the Starred section. You can also view More Details about a particular show by clicking Read More.",
      technologies: "ReactJs | SASS ",
      link: "https://amartya324.github.io/box-office/",
      github: "https://github.com/amartya324/box-office",
    },
    {
      id: 3,
      title: "Tic Tac Toe game",
      img: IMG3,
      description:
        "Tic-Tac-Toe is a two-player game in which the players fill up nine empty rectangles in a table with either an X or an O when it is their turn. Once someone succeeds to line up their sign vertically or horizontally without an interruption, that player wins.",
      technologies: "ReactJs | JavaScript | SCSS ",
      link: "https://tic-tac-toe324.netlify.app/",
      github: "https://github.com/amartya324/tic-tae-toe",
    },
    {
      id: 4,
      title: "ToDo-List",
      img: IMG2,
      description:
        "toDo-List app made in reactJs using useState Hook. The data is saved in local storage of your browser",
      technologies: "ReactJs | JavaScript | CSS",
      link: "https://todo-list324.netlify.app//",
      github: "https://github.com/amartya324/ToDo-List",
    },

    {
      id: 5,
      title: "Color Generator",
      img: IMG5,
      description:
        "Using color shades generator you can generate multiple shades of a single color. Simply enter color in rgb, hex, name or pick from palette and get different shades of the color. Clicking on these values will automatically copy it to your clipboard.",
      technologies: "ReactJs | JavaScript | CSS",
      link: "https://color-generator-shades.netlify.app/",
      github: "https://github.com/amartya324/Color-Generator",
    },
    {
      id: 6,
      title: "Lorem Ipsum",
      img: IMG6,
      description:
        "TIRED OF BORING LOREM IPSUM??? Use this... a free text generator that replaces lorem ipsum with some text that you can build in paragraph form",
      technologies: "ReactJs| JavaScript | CSS",
      link: "https://lorem-ipsum-substitute.netlify.app/",
      github: "https://github.com/amartya324/Lorem-Ipsum",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Visit Website
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
